import React, { forwardRef } from "react";
import { SelectParams } from "./types";
import { Wrapper } from "./elements";
import { Select as AntSelect } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { theme } from "../../../config";

const Select = (props: SelectParams, ref: any) => {
  const {
    disabled,
    handleChange,
    defaultValue,
    optionItems,
    inputItems,
    placeholder,
    getPopupContainer,
    value,
    $onDropdownVisibleChange,
    onMouseDown,
    dropdownStyle,
  } = props;

  return (
    <Wrapper {...props}>
      <AntSelect
        dropdownStyle={dropdownStyle}
        onDropdownVisibleChange={$onDropdownVisibleChange}
        placeholder={placeholder}
        style={{ width: "100%" }}
        defaultValue={defaultValue || undefined}
        dropdownMatchSelectWidth={false}
        suffixIcon={
          <DownOutlined style={{ color: theme.colors.neutral.black2 }} />
        }
        value={value}
        onChange={handleChange}
        disabled={disabled || false}
        getPopupContainer={getPopupContainer}
        ref={ref}
        dropdownRender={(optionItems) => (
          <>
            {optionItems}
            {inputItems && inputItems}
          </>
        )}
        onMouseDown={onMouseDown}
      >
        {optionItems}
      </AntSelect>
    </Wrapper>
  );
};

export default forwardRef(Select);
